import React from "react";
import LazyLoad from "react-lazyload";

function withLazyLoad<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- any is needed to make extends infer prop types
  T extends React.ComponentType<any>,
  Props extends React.ComponentProps<T>
>(Component: T) {
  return ({
    height,
    offset,
    ...props
  }: {
    height: number;
    offset: number;
  } & Props) => (
    <LazyLoad height={height} offset={offset} once>
      <Component {...(props as Props)} />
    </LazyLoad>
  );
}

export default withLazyLoad;
